import { RootState } from '..';

export const selectServiceMissionsData = (state: RootState) => state.service.missionStats;
export const selectAnnouncementsData = (state: RootState) => state.service.announcements;
